const AIDesk = {
  "结束会话": "结束会话",
  "转人工服务": "人工服务",
  "跳转": "跳转",
  "立即填写": "立即填写",
  "已提交": "已提交",
  "提交": "提交",
  "查看内容": "查看内容",
  "请填写必填项": "请填写必填项",
  "请输入内容": "请输入内容",
  "如果满意请给好评哦～": "如果满意请给好评哦～",
  "请对本次服务进行评价": "请对本次服务进行评价",
  "提交评价": "提交评价",
  "服务评价": "服务评价",
  "并发限制": "当前咨询人数较多，请稍后再试",
  "分支选项异常": "内容异常，请检查任务流配置",
  "满意": "满意",
  "不满意": "不满意",
  "感谢您的反馈，我们会持续优化改进": "感谢您的反馈，我们会持续优化改进",
  "您遇到了哪方面的问题": "您遇到了哪方面的问题",
  "其他反馈内容": "其他反馈内容",
  "取消": "取消",
  "答非所问": "答非所问",
  "未匹配相关内容": "未匹配相关内容",
  "信息错误": "信息错误",
  "上下文理解错误": "上下文理解错误",
  "格式不规范": "格式不规范",
  "内容不完整": "内容不完整",
  "file 大小超过 100MB，无法发送": "file 大小超过 100MB，无法发送",
  "image 大小超过 20MB，无法发送": "image 大小超过 20MB，无法发送",
  "video 大小超过 100MB，无法发送": "video 大小超过 100MB，无法发送",
  "提交成功": "提交成功",
  "userID 只能包含可打印 ASCII 字符": "userID 只能包含可打印 ASCII 字符",
  "userID 不能包含'administrator'": "userID 不能包含'administrator'",
  "userID 长度不能超过45字节": "userID 长度不能超过45字节",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？",
  "该回复由AI生成，内容仅供参考": "该回复由AI生成，内容仅供参考",
  "排队等待中": "排队等待中",
  "排队等待话术": "抱歉，当前所有人工客服已达到服务上限，请耐心等待，我们很快就来接待您，感谢您的理解。",
  "当前前方排队人数": "当前前方排队人数",
  "结束排队": "结束排队",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "评价提交超过3分钟，无法更改。感谢您的反馈！",
  "不能发送空白消息": "不能发送空白消息",
  "确认转人工": "确认转人工",
}
export default AIDesk;
